<template>
    <div class="personal_center">
        <div class="warp1200 fix">
            <PersonalCenterMenu :activeIndex="0" />
            <div class="f-fr center_right">
                <!-- 用户信息 -->
                <user-info-card></user-info-card>

                <!-- 订单 -->
                <booking-list></booking-list>

                <!-- 航线推荐 -->
                <promo-cruise></promo-cruise>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonalCenterMenu from '@/components/User/PersonalCenterMenu'
    import UserInfoCard from '@/components/User/UserInfoCard'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import BookingList from '@/components/Booking/BookingList/BookingList'

    export default {
        name: "UserCenter",
        components: {
            PersonalCenterMenu,
            UserInfoCard,
            PromoCruise,
            BookingList
        },
        data () {
            return {}
        },
        beforeMount() {
            this.init()
        },
        methods: {
            async init () {
                await this.pageInit()
            },
            async pageInit () {
                const userToken = this.$store.state.user.userToken
                if (!userToken) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return false
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .personal_center {
        background: #f5f5f5;
        .center_right {
            padding-left: 20px;
            width: 965px;
        }
    }
</style>
